import styled from 'styled-components';

import { Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { BarLabelContainerProps } from './socialMediaLoginBar.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const BarLabelContainer: StyledComponent<'div', BarLabelContainerProps> = styled.div<BarLabelContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${({ $margin }: BarLabelContainerProps): string => `margin: ${$margin}`};
`;

export const BarLabelLine: StyledComponent<'div'> = styled.div`
  border-bottom: 1px solid ${Color.Stroke};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 100%;
`;

export const BarLabel: StyledComponent<'div'> = styled.div`
  color: ${Color.Gray500};
  background-color: ${Color.White};
  padding: 0 16px;
  z-index: ${ZIndex.Min};
  font-size: 14px;
  line-height: 18px;
`;

export const SocialMediaIcons: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const SocialMediaButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  width: calc(33.33% - 3px);
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Color.Gray300};

  & + & {
    margin-left: 4px;
  }
`;

export const SocialMediaIcon: StyledComponent<'img'> = styled.img``;
